import PIEText from '@src/shared/components/PIEText';
import React from 'react';
import styles from './ConnectionCodeContainer.module.scss';
interface componentProps {
  code: string;
}
const ConnectionCodeContainer = ({ code }: componentProps) => {
  const formatConnectionCode = (code: string) => {
    if (code.length !== 12) {
      return 'INVALID CODE';
    }
    var textNode = document.createTextNode(code);
    textNode.insertData(2, ' - ');
    textNode.insertData(8, ' - ');
    textNode.insertData(14, ' - ');
    return textNode.textContent;
  };

  const onCopyHandler = (event: React.ClipboardEvent<HTMLDivElement>) => {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    clipboardData.setData('text/plain', code);
    event.preventDefault();
  };

  const onClickHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const selectedElement = e.target as HTMLElement;
    const range = document.createRange();
    range.selectNodeContents(selectedElement);
    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);
  };

  return (
    <div
      className={styles.connectionCodeContainer}
      onCopy={onCopyHandler}
      onClick={onClickHandler}
      id="qr-connection-code-container"
    >
      <PIEText
        size={'var(--xds-font-size-24)'}
        fontWeight="var(--xds-font-weight-extrabold)"
        align="center"
        text={formatConnectionCode(code)}
      ></PIEText>
    </div>
  );
};

export default ConnectionCodeContainer;
